import React from 'react';
import { Link } from 'react-router';
import styled, { css } from 'styled-components';
import { Text } from '../../../design-system';
import { findItemViaPathname, displayText } from '../../../helpers/utils';
import Tooltip from '../../../components/Tooltip';

const UL = styled.ul`
  list-style: none;
  margin: 10px 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const LI = styled.li`
  cursor: pointer;
  margin-left: 20px;
  padding: 5px 0;
`;

const StyledLink = styled(Link)<{ selected?: any }>`
  ${({ selected, theme: { colors } }) => css`
    color: ${selected ? colors.primary : 'inherit'};
    text-decoration: none;

    &:hover {
      color: ${selected ? colors.primary : colors.grey};
    }
  `}
`;

const AllProgramsLI = styled(LI)`
  cursor: default;
`;

const ProgramLI = styled(LI)`
  list-style-type: square;
`;

const ProgramText = styled(Text)<{ selected?: any }>`
  ${({ selected, theme: { colors } }) => css`
    color: ${selected && colors.secondaryLight};
    font-weight: ${selected && 700};
    font-size: 14px;
  `}
`;

interface InnerSideBarProps {
  views: any[];
  currentView: any;
  data: { id: any; programs: any[] };
  pathname: string;
}

const InnerSideBar = ({
  views,
  currentView,
  data: { id, programs },
  pathname,
}: InnerSideBarProps) => (
  <UL>
    {views.map(({ name, route }) =>
      name === 'Programs' ? (
        <AllProgramsLI key={name}>
          <StyledLink to={route} selected={currentView ? currentView.route === route : false}>
            <Text fontSize={14}>{name}</Text>
          </StyledLink>
          {currentView && currentView.route === route && programs.length > 0 && (
            <UL>
              {programs
                .sort((a, b) =>
                  a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1,
                )
                .map((program) => {
                  const selectedProgram = findItemViaPathname(
                    programs,
                    pathname,
                  );
                  const selected =
                    selectedProgram && selectedProgram.id === program.id;
                  const { text, more } = displayText(program.name, 22);
                  return (
                    <ProgramLI key={program.id}>
                      <StyledLink
                        to={`/vault/${id}/program-case-statements/${program.id}`}
                        selected={selected}
                      >
                        <ProgramText selected={selected}>
                          {text}
                          {more && <Tooltip text={program.name}>...</Tooltip>}
                        </ProgramText>
                      </StyledLink>
                    </ProgramLI>
                  );
                })}
            </UL>
          )}
        </AllProgramsLI>
      ) : (
        <LI key={name}>
          <StyledLink to={route} selected={currentView ? currentView.route === route : false}>
            <Text fontSize={14}>{name}</Text>
          </StyledLink>
        </LI>
      ),
    )}
  </UL>
);

export default InnerSideBar;
